import CONFIG from "./config";
const NEXUS_CONST = {
  SEARCH_USER_IDENTITY: "v1/search",
  SITE_INFO_URL: "Home/GetSiteDetails?sbgid=all&siteid=all",
  GET: "get",
  POST: "post",
  PUT: "put",
  SITE_LOCATION_URL: "Home/GetSBGLocation?sbgId=",
  GET_USER_DATA: "home/GetUserData?siteId=",
  UPDATE_PIN_SITE: "home/pinSite?",
  FETCH_TIERS: "DigitalTier/getTierData?siteid=",
  FETCH_TPL: "digitaltier/getCustomLayout?",
  FETCH_RAIL_GRID: "DigitalTier/GetActionData?tierId=",
  FETCH_RAIL_GRID_SITEWISE: "DigitalTier/GetActionData?siteId=",

  UPDATE_ACTION: "DigitalTier/UpdateAction",
  CREATE_ACTION: "DigitalTier/AddAction",
  DELETE_ACTION: "DigitalTier/DeleteAction?",
  FETCH_PEOPLE: "DigitalTier/GetPeopleNameData?",
  FETCH_TABLEUA_DATA: "DigitalTier/GetDisplayData?tierId=",
  GET_TIER_INFO: "home/GetTierDetails?",
  FETCH_MOC: "digitaltier/getMOCData?tierId=",
  UPDATE_MOC: "digitaltier/manageMOC",
  DELETE_MOC: "digitalTier/deleteMOC?id=",
  FETCH_GEMBA: "digitaltier/getGembaTrackingData?",
  UPDATE_GEMBA: "digitaltier/manageGemba",
  GET_MESSAGES: "digitaltier/getMessageOfTheDay?",
  UPDATE_MESSAGES: "digitaltier/manageMessageOfTheDay",
  GET_ALERTS: "digitaltier/getAlertsRR?",
  UPDATE_ALERTS: "digitaltier/manageAlertsandRR",
  GET_DOWNTIME: "DigitalTier/GetMetricData?metricID=1&tierId=",
  GET_REASON_CODES: "DigitalTier/GetReasonCodeData?metricID=1&",
  ADD_DOWNTIME_METRIC: "DigitalTier/AddMetricData",
  UPDATE_DOWNTIME_METRIC: "DigitalTier/UpdateMetricData",
  DELETE_DOWNTIME_METRIC: "DigitalTier/DeleteMetricData?metricId=",
  FETCH_CALENDAR_PLAN: "DigitalTier/GetCalendarPlan?",
  ADD_CALENDAR_PLAN: "DigitalTier/AddCalendarPlan",
  UPDATE_CALENDAR_PLAN: "DigitalTier/UpdateCalendarPlan",
  DELETE_CALENDAR_PLAN: "DigitalTier/DeleteCalendarPlan?id=",
  FETCH_SITE_LIST: "settings/getSiteListData?siteid=",
  UPDATE_SITE_DATA: "settings/manageSite",
  GET_PEOPLE_DATA: "settings/getPeopleListData?siteid=",
  FETCH_REASON_CODE_LIST: "settings/getReasonCodeListData?&metricId=1&siteid=",
  FETCH_VIZUALIZATION: "settings/getVizualizationListData?siteid=",
  UPDATE_PEOPLE: "settings/managePeople",
  DELETE_PEOPLE: "settings/deletePeople?id=",
  UPDATE_REASON_CODE: "settings/manageReasonCode",
  DELETE_REASON_CODE: "settings/deleteReasonCode?id=",
  UPDATE_VIZUALIZATION: "settings/manageVizualization",
  DELETE_VIZUALIZATION: "settings/deleteVizualization?id=",
  FETCH_TIER_LIST: "settings/getTierListData?siteid=",
  FETCH_ABOVE_TIER_LIST: "settings/getAboveTierListData?siteid=",
  MANAGE_TIER: "settings/manageTier",
  DELETE_TIER: "settings/deleteTier?id=",
  DELETE_SITE: "settings/DeleteSite?id=",
  UPDATE_TEMPLATE: "digitaltier/manageCustomLayout",
  UPDATE_MEET_TIME: "digitaltier/manageTimer",
  FETCH_PINNED_SITES: "home/GetPinnedSites?sbg=",
  GET_SESSION_INFO: "Home/GetSessionData",
  MANAGE_ACTIONS: "digitaltier/ManageActions",
  GET_USER_BY_CODE: "Home/getUserInfoByCode?code=",
  VALIDATE_SESSION: "Home/validatesession",
  QUICK_LINK_INFO: "home/quickLink",
  UPDATE_USER_LOG: "home/addUserMetrics",
  BLOB: "blob",
  // OPEN_WEATHER_URL: "Home/GetWeatherDetails?",
  FETCH_INCIDENT: "digitaltier/getIncidentData?tierId=",
  UPDATE_INCIDENT: "digitaltier/manageIncident",
  DELETE_INCIDENT: "digitalTier/deleteIncident?id=",
  FETCH_SITE_INFO: "home/GetSitewiseTierData?siteId=",
  FETCH_GEMBA_TYPES: "settings/getGembaTypeListData?siteid=",
  DEL_GEMBA_TYPE: "settings/deleteGembaType?id=",
  UPDATE_GEMBA_TYPE: "settings/manageGembaType",
  FETCH_INCIDENT_TYPE_LIST:
    "settings/getIncidentTypeListData?&metricId=1&siteid=",
  UPDATE_INCIDENT_TYPE: "settings/manageIncidentType",
  DELETE_INCIDENT_TYPE: "settings/deleteIncidentType?id=",
  GET_INCIDENT_TYPE: "DigitalTier/GetIncidentType?metricID=1&",
  SAVE_LAYOUT_FILE: "digitaltier/saveLayoutAttachment?",
  FETCH_CALENDAR_UPCOMING_EVENT: "Home/fetchCalendarUpcomingEvent?",
  FETCH_CALENDAR_EVENT_TYPES: "settings/getCalendarEventTypeListData?siteid=",
  UPDATE_CALENDAR_EVENT_TYPE: "settings/manageCalendarEventType",
  DEL_CALENDAR_EVENT_TYPE: "settings/deleteCalendarEventType?id=",
  GET_USER_DETAILS: "settings/getUserDataById?employeeId=",
  SEND_MAIL: "AdminConsole/SendMailTemplate",
  FETCH_TABLEAU_ACCESS: "Home/GetTableauAccessDetails",
  FETCH_USER_CLUSTER: "Home/GetUserCluster",
  ADD_USER_CLUSTER: "Home/AddUserCluster",
  UPDATE_USER_CLUSTER: "Home/UpdateUserCluster",
  DELETE_USER_CLUSTER: "Home/DeleteUserCluster",
  FETCH_GALLERY: "AdminConsole/getNewsletterImages",
  ADD_GALLERY_FILE: "AdminConsole/manageNewsletterImages",
  DELETE_GALLERY_FILE: "AdminConsole/DeleteAttachment?id=",
  FETCH_USER_HIGHEST_TIER: "DigitalTier/GetHighestTierofEmp",
  FETCH_SITE_HIGHEST_TIER: "DigitalTier/GetHighestTierofSite?siteid=",
  FETCH_KAIZEN_CATEGORIES: "Kaizen/getKaizenDDL?type=DDLCATEGORY&siteId=",
  FETCH_KAIZEN_AREA: "Kaizen/getKaizenDDL?type=DDLAREA&SiteID=",
  FETCH_KAIZEN_CELL: "Kaizen/getKaizenSubAreaDDL?type=DDL_SUB_AREA&",
  FETCH_KAIZEN_USER_DATA: "home/GetUserData?siteId=",
  FETCH_KAIZEN_ALL_USERS: "adminconsole/getalluserslist",
  FETCH_MANAGER_DETAILS: "Kaizen/getManagerDetails?mailId=",
  ADD_KAIZEN_RAISE_CI: "Kaizen/ManageKaizen",
  MANAGE_KAIZEN_RAISE_CI: "Kaizen/ManageKaizen",
  UPDATE_KAIZEN_RAISE_CI: "Kaizen/UpdateKaizen",
  FETCH_NOMINATION_KAIZEN_DATA: "Kaizen/getNominationKaizenData?siteId=",
  FETCH_KAIZEN_SITE_FOCAL_INFO: "Kaizen/getKaizenSiteFocalInfo?SiteID=",
  GET_KAIZEN_CI_LIST: "Kaizen/getKaizenListDetails?",
  GET_IMAGE: "Home/fetchFileData",
  GET_NOMINATION: "Kaizen/getNominationKaizenData?siteId=",
  MANAGE_NOMINATION: "Kaizen/manageRecognitionKaizenData",
  MANAGE_RECOGNITION: "Kaizen/manageNominationKaizenData",
  FETCH_KAIZEN_DATA_BY_ID: "Kaizen/getKaizenListDetailsById",
  FETCH_OPH_LIST_BY_TIER: "digitaltier/getOPHListByTier?tierid=",
  FETCH_OPH_BY_ID: "digitaltier/getOPHById?prodId=",
  MANAGE_OPH: "digitaltier/manageOPH",
  DELETE_OPH: "digitaltier/deleteOPHById?id=",
  FETCH_ADMIN_NOMINATED_KAIZEN_DATA:
    "KaizenAdmin/getAdminNominatedKaizenData?siteId=",
  MANAGE_ADMIN_NOMINATED_KAIZEN_DATA:
    "KaizenAdmin/manageAdminNominatedKaizenData",
  UPDATE_OPH_SLOT: "digitaltier/updateOPHSlotById?ProdId=",
  FETCH_KAIZEN_AREA_LIST: "KaizenAdmin/getAreaList?siteId=",
  FETCH_KAIZEN_ADMIN_LIST: "KaizenAdmin/getDeleteKaizenList?siteId=",
  DELETE_KAIZEN_ADMIN_BY_ID: "KaizenAdmin/deleteKaizenByIdForAdmin?siteCode=",
  FETCH_OPH_MISS_REASON_CODES: "settings/getOPHReasonCodeListData?siteId=",
  UPDATE_OPH_MISS_REASON_CODES: "settings/manageOPHReasonCode",
  DELETE_OPH_MISS_REASON_CODES: "settings/deleteOPHReasonCode?id=",
  FETCH_KAIZEN_LINE_LIST: "KaizenAdmin/getLineList?siteId=",
  FETCH_KAIZEN_CELL_LIST: "KaizenAdmin/getCellList?siteId=",
  MANAGE_KAIZEN_AREA: "KaizenAdmin/manageKaizenArea",
  MANAGE_KAIZEN_CELL: "KaizenAdmin/manageKaizenCell",
  DELETE_KAIZEN_CELL: "kaizenAdmin/deleteKaizenCell?id=",
  MANAGE_KAIZEN_LINE: "KaizenAdmin/manageKaizenLine",
  DELETE_KAIZEN_LINE: "kaizenAdmin/deleteKaizenLine?id=",
  FETCH_KAIZEN_CELL_OPTIONS: "Kaizen/getKaizenSubAreaDDL?type=DDL_CELL&",
  FETCH_HSECOMMUNICATION: "digitaltier/getHSECommunicationData?siteid=",
  UPDATE_HSECOMMUNICATION: "digitaltier/manageHSECommunication",
  FETCH_SHIFTSCHEDULE: "digitaltier/getOPHShiftScheduleData?siteId=",
  FETCH_OPH_DETAILS: "digitaltier/getOPHDetails?siteId=",
  FETCH_OPH_MISS_REASON_CODE_DETAILS_BY_ID:
    "digitaltier/getOPHMissReasonCodeDetails?ophId=",
  MANAGE_OPH_MISS_REASON_CODE_DETAILS:
    "digitaltier/manageOPHMissReasonCodeDetails",
  FETCH_OPH_GRAPH_DATA_BY_ID: "digitaltier/getOPHGraphDetailsById?prodId=",
  FETCH_OPH_MISS_REASON_GRAPH: "digitaltier/GetOPHMissReasonGraph?tierId=",
  FETCH_OPH_ATTAINMENT_GRAPH: "digitaltier/GetOPHAttainmentGraph?tierId=",

  FETCH_OPH_MISS_REASON_CODE_QUANTITY_BY_ID:
    "digitaltier/getMissReasonCodeQuantityById?prodId=",
  GET_APPROVER_HIGHEST_TIER: "settings/GetApproverListbyHighestTier?siteid=",
  MANAGE_RPS: "digitalTier/ManageRPS",
  GET_REASON_CODE_BY_FREQUENCY: "digitalTier/GetReasonCodeByFrequency?tierId=",
  GET_RPS_RAIL: "ProblemSolving/getCompletionPlanData?rpsId=",
  MANAGE_RPSRAIL: "ProblemSolving/ManageMiniRAIL",
  RPS_ATTACHMENT: "digitalTier/RPSAttachment?",
  FETCH_RPS_GRID: "DigitalTier/GetRPSTrackingList?tierId=",
  FETCH_RCA_GRID: "ProblemSolving/getRCAData?rpsId=",
  DELETE_RPS_DATA: "DigitalTier/deleteRPSData?rpsId=",
  FETCH_PS_DATA: "ProblemSolving/getProblemSovingDatabyId?rpsId=",
  MANAGE_PS_DATA: "ProblemSolving/ManageProblemSolvingData",
  FETCH_ALL_RPS_DATA: "ProblemSolving/getProblemSovingDatabyId?rpsId=",
  POST_ALL_RPS_DATA: "ProblemSolving/ManageProblemSolvingData",
  POST_RPS_GRID_DATA: "ProblemSolving/ManageRCA",
  GET_SOLUTION_DATA: "DigitalTier/GetRPSSolutionList?RPSId=",
  MANAGE_SOLUTION_DATA: "DigitalTier/manageSolutionList",
  DELETE_SOLUTION_DATA: "DigitalTier/deleteSolutionData?id=",
  ADD_CONFIRM_RESULT: "ProblemSolving/ManageResultData",
  RCA_ATTACHMENT: "ProblemSolving/ManageAttachments",
  DELETE_RCAGRID_DATA: "ProblemSolving/DeleteRCA?id=",
  FETCH_RCA_ATTACHMENT: "ProblemSolving/getAttachmentsData?rpsId=",
  FETCH_CONFIRMRESULT_GRID: "ProblemSolving/getResultDatabyId?rpsId=",
  PUT_CONFIRMRESULT_ATTACHMENT: "ProblemSolving/ManageAttachments",
  FETCH_CONFIRMRESULT_ATTACHMENT: "ProblemSolving/getAttachmentsData?rpsId=",
  DELETE_ATTACHMENT_DATA: "ProblemSolving/DeleteAttachments?id=",
  DELETE_RESULTS_ATTACHMENT_DATA: "ProblemSolving/DeleteAttachments?id=",
  FETCH_RAPID_EXPERIMENT: "ProblemSolving/getExperimentData?rpsId=",
  MANAGE_EXPERIMENT: "ProblemSolving/ManageExperiment",
  DELETE_EXPERIMENT: "ProblemSolving/DeleteAttachments?id=",
  FETCH_Experiment_ATTACHMENT: "ProblemSolving/getAttachmentsData?rpsId=",
  FETCH_REASON_CODE_LIST_FORADMIN:
    "AdminConsole/getReasonCodeListData?&metricId=1",
  GET_RESONTYPES_DATA: "settings/getReasonTypeData?Type=",
  GET_CUSTOMSQDICP_DATA: "ProblemSolving/CustomSQDICP?",
  POST_ALL_RCA_DATA: "ProblemSolving/ManageRCAData",
  POST_MANAGE_EXPERIMENT: "ProblemSolving/ManageExperimentData",
  GET_CUSTOMSQDICPTIER_DATA: "ProblemSolving/CustomSQDICP_Tier?",
  POST_MANAGE_COMPLETIONPLAN: "ProblemSolving/ManageCompletionPlanData",
  POST_MANAGE_SOLUTIONAPPROCH: "ProblemSolving/ManageSolutionApproachData",
  GET_DLE_MISS_REASON_PARETO_DATA: "DLE/GetDLEMissReasonCodeFrequencyById",
  GET_DLE_RUN_CHART_DATA: "DLE/DLERunChart?",
  UPDATE_REASON_CODE_FORADMINCONSOLE: "AdminConsole/manageReasonCode",
  DELETE_REASON_CODE_FORADMINCONSOLE: "AdminConsole/deleteReasonCode?id=",
  GET_METRIC_ANDON: "DLE/metricAndon?",
  GET_FPY_MISS_REASON_PARETO_DATA: "FPY/GetFPYMissReasonCodeFrequencyById",
  GET_FPY_RUN_CHART_DATA: "FPY/FPYRunChart?",
  GET_DLE_DETAILS: "DLE/getPreviousDleDetails",
  GET_LID_PLANT_DATA: "AdminConsole/",
  GET_USER_DATA_ACCESS: "home/GetUserDetailsApplicationAccess?",
  GET_DLE_DETAILS: "DLE/getPreviousDleDetails",
  POST_RAILGRID_COLUMNSSAVE: "Home/ManageGridCustomData",
  GER_GRID_SETTINGS: "Home/getGridCustomization",
  FETCH_SMESS_REASON_CODE_LIST_FORADMIN:
    "AdminConsole/getSMESSReasonCodeListData",
  UPDATE_SMESS_REASON_CODE_FORADMINCONSOLE:
    "AdminConsole/manageSMESSReasonCode",
  DELETE_SMESS_REASON_CODE_FORADMINCONSOLE:
    "AdminConsole/DeleteSMESSReasonCode?reasonId=",
  GET_SITE_LINES: "settings/getLinesbySite?siteid=",
  GET_MATERIAL_DATA: "settings/getMasterMaterialData?TierID=",
  FETCH_MATERIAL_LIST: "settings/getMaterialDatabyTierID?TierID=",
  FETCH_BULK_MATERIAL_LIST: "settings/getBulkMaterialDatabyTierID?TierID=",
  MANAGE_MATERIALDATA: "settings/ManageMaterialData",
  MANAGE_BULK_MATERIAL_DATA: "settings/ManageMaterialListData",
  GET_TIMEZONE_LIST: "settings/getTimezoneData",
  FETCH_OPH_DASHBOARD_DATA: "digitaltier/Getophdatanew?siteId=",
  FETCH_SCHEDULED_REPORT: "settings/getScheduleReportData?siteId=",
  FETCH_SCHEDULED_REPORT_LIST_DATA:
    "settings/getScheduleReportTierListData?siteId=",
  MANAGE_SCHEDULED_REPORT: "settings/manageScheduleReportData",
  DELETE_SCHEDULE_REPORT_DATA: "settings/RemoveScheduleReportData?tierId=",
  FETCH_SPS_FISHBONE: "ProblemSolving/getFishboneData?rpsId=",
  FETCH_SETTINGS_MULTI_SURVEY_DATA:
    "MultiSurvey/getSettingsMultiSurveyData?parentTierId=",
  MANAGE_SETTINGS_MULTI_SURVEY_DATA:
    "MultiSurvey/manageSettingsMultiSurveyData",
  REMOVE_SETTINGS_MULTI_SURVEY_DATA:
    "MultiSurvey/removeSettingsMultiSurveyData?surveyId=",
  FETCH_SETTINGS_MULTI_SURVEY_TIERS_DATA:
    "MultiSurvey/getSettingsMultiSurveyTiersData?surveyId=",
  MANAGE_SETTINGS_MULTI_SURVEY_TIERS_DATA:
    "MultiSurvey/manageSettingsMultiSurveyTiersData",
  FETCH_QUESTIONS_SURVEY:
    "MultiSurvey/getSettingsMultiSurveyQuestionData?surveyId=",
  FETCH_MULTI_SURVEY_NAME_DATA: "MultiSurvey/getMultiSurveyNameData?tierId=",
  MANAGE_SURVEY_QUESTIONS_DATA: "MultiSurvey/manageSettingsQuestionsData",
  FETCH_SPS_FIVEWHY: "ProblemSolving/getWhyModelData?rpsId=",
  MANAGE_A3_DATA: "A3/ManageA3Data",
  FETCH_A3_DATA: "A3/getA3GeneralInfo?a3ID=",
  MANAGE_A3_GENERAL_INFO_DATA: "A3/manageA3GeneralInfo",
  FETCH_TARGETSTATE_A3: "A3/GetTargetStateData?id=",
  MANAGE_TARGET_STATE: "A3/ManageTargetStateData",
  FETCH_ATTACHMENT_A3: "A3/getAttachmentsData?a3Id=",
  MANAGE_ATTACHMENT_A3: "A3/ManageAttachments",
  DELETE_ATTACHMENT_A3: "A3/DeleteAttachments?id=",
  FETCH_A3_GAP_SOLUTION_DATA: "A3/getA3SolutionApproach?a3ID=",
  MANAGE_A3_GAP_SOLUTION_DATA: "A3/manageA3SolutionApproach",
  FETCH_A3_GAP_DATA: "A3/getA3SolutionApproach?a3ID=",
  FETCH_A3_GAP_ANALYSIS_DATA: "A3/GetGapAnalysisData?id=",
  FETCH_A3_GAP_ANALYSIS_DATA: "A3/GetGapAnalysisData?a3ID=",
  MANAGE_GAP_ANALYSIS_DATA: "A3/ManageGapAnalysisData",
  FETCH_EXPERIMENT_A3: "A3/getExperimentData?a3ID=",
  MANAGE_EXPERIMENTS_DATA: "A3/ManageExperimentData",
  FETCH_A3_FISHBONE: "A3/getFishboneData?id=",
  FETCH_A3_FIVEWHY: "A3/getWhyModelData?id=",
  FETCH_A3_COMPLETION_PLAN: "A3/getA3CompletionPlanData?a3ID=",
  MANAGE_A3_COMPLETION_PLAN: "A3/manageA3CompletionPlan",
  FETCH_A3_GRID_DATA: "A3/getA3SummaryListData?tierID=",
  DELETE_A3_GRID_DATA: "A3/deleteA3SummaryList?a3ID=",
  FETCH_A3_CONFIRMEDRESULTS: "A3/getResultsData?a3ID=",
  FETCH_A3_CONFIRMEDRESULTS_GRAPH: "A3/getResultsGraph?a3ID=",
  MANAGE_RESULTS_DATA: "A3/ManageResultsData",
  MANAGE_RESULTS_FREQUENCY_DATA: "A3/ManageResultFrequency",
  GET_MODULE_DATA: "ProblemSolving/getModuleDetails?tierID=",
  GET_REASON_CODE_FREQUENCY_BY_MODULE:
    "ProblemSolving/getReasonCodeFrequencyByModule?tierId=",
  MANAGE_LANGDATA: "ReasonCodeRevamp/ManageLanguageData",

  SBG_ICON_CLS: {
    Aero: "at",
    CORP: "corporate",
    BA: "ba",
    ESS: "ess",
    IA: "ia",
    ADMIN: "admin console",
  },
  SBG_LABEL_TXT: {
    AT: "at",
    CORP: "all sites",
    BA: "ba",
    ESS: "ess",
    IA: "ia",
    ADMIN: "admin console",
    Aero: "Aero",
  },
  DND_TYPES: {
    MENU_CARD: "MENU_CARD",
  },
  MENU_ICONS: [
    "performance",
    "safety",
    "quality",
    "deliver",
    "inventory",
    "cost",
    "people",
    "setting",
    "customize",
  ],
  MENU_SQDICP: ["safety", "quality", "delivery", "inventory", "cost", "people"],
  APPS_LIST_OWNER: [
    {
      id: "digital",
      label: "Digital Tier",
      name: "Digital Tier",
      icon: "digital",
    },
    {
      id: "settings",
      label: "Settings",
      name: "Settings",
      icon: "maintenance",
    },
    { id: "rail", label: "Rail", name: "Rail", icon: "action" },
    { id: "calendar", label: "Calendar", name: "Calendar", icon: "calendar" },
    {
      id: "standardWork",
      label: "Help With Nexus",
      name: "Help With Nexus",
      icon: "inventory",
    },
  ],
  APPS_LIST_MEMBER: [
    {
      id: "digital",
      label: "Digital Tier",
      name: "Digital Tier",
      icon: "digital",
    },
    { id: "rail", label: "Rail", name: "Rail", icon: "action" },
    { id: "calendar", label: "Calendar", name: "Calendar", icon: "calendar" },
    {
      id: "standardWork",
      label: "Help With Nexus",
      name: "Help With Nexus",
      icon: "inventory",
    },
  ],
  L_SERIES: ["744", "747", "748", "749", 744, 747, 748, 749],
  RED: "RED",
  GREEN: "GREEN",
  YELLOW: "YELLOW",
  ENV: CONFIG.ENV,
  LOCAL_SESSION: CONFIG.SESS_KEY,
  REDIRECT_URI: CONFIG.SESS_REDITECT_URI,
  APP_ID: "NEXUS",
  API_ENDPOINT: CONFIG.API_ENDPOINT,
  SPS_STEPS: [
    { id: 0, txt: "G", title: "General Information", visited: 0, isOpen: true },
    {
      id: 1,
      txt: "1",
      title: "Reason for Action",
      visited: 0,
      isSaved: false,
      isOpen: false,
    },
    {
      id: 2,
      txt: "2",
      title: "Breakdown the Problem",
      visited: 0,
      isSaved: false,
      isOpen: false,
    },
    {
      id: 3,
      txt: "3",
      title: "Target State",
      visited: 0,
      isSaved: false,
      isOpen: false,
    },
    {
      id: 4,
      txt: "4",
      title: "Root Cause Analysis",
      visited: 0,
      isSaved: false,
    },
    {
      id: 5,
      txt: "5",
      title: "Solution Approach",
      visited: 0,
      isSaved: false,
      isOpen: false,
    },
    {
      id: 6,
      txt: "6",
      title: "Rapid Experiments",
      visited: 0,
      isSaved: false,
      isOpen: false,
    },
    {
      id: 7,
      txt: "7",
      title: "Completion Plan",
      visited: 0,
      isSaved: false,
      isOpen: false,
    },
    {
      id: 8,
      txt: "8",
      title: "Confirmed Results",
      visited: 0,
      isSaved: false,
      isOpen: false,
    },
    {
      id: 9,
      txt: "9",
      title: "Insights & Actions",
      visited: 0,
      isSaved: false,
      isOpen: false,
    },
  ],
  BenefitData: [
    {
      value: "1",
    },
    {
      value: "2",
    },
    {
      value: "3",
    },
    {
      value: "4",
    },
    {
      value: "5",
    },
    {
      value: "6",
    },
    {
      value: "7",
    },
    {
      value: "8",
    },
    {
      value: "9",
    },
    {
      value: "10",
    },
  ],
  DifficultyData: [
    {
      value: "1",
    },
    {
      value: "2",
    },
    {
      value: "3",
    },
    {
      value: "4",
    },
    {
      value: "5",
    },
    {
      value: "6",
    },
    {
      value: "7",
    },
    {
      value: "8",
    },
    {
      value: "9",
    },
    {
      value: "10",
    },
  ],
  statusList: [
    {
      value: "Open",
    },
    {
      value: "Close",
    },
  ],
  SixMInputTypeList: [
    { value: "Man", key: "Man" },
    { value: "Material", key: "Material" },
    { value: "Machine", key: "Machine" },
    { value: "Method", key: "Method" },
    { value: "Measurement", key: "Measurement" },
    { value: "Environment", key: "Environment" },
  ],
  SMESSReasonList: [
    { value: "Safety", key: "Safety" },
    { value: "Methods", key: "Methods" },
    { value: "Equipment", key: "Equipment" },
    { value: "Supplies", key: "Supplies" },
    { value: "Staff", key: "Staff" },
  ],

  SixMInputTypeListMexican: [
    { value: "Hombre", key: "Hombre" },
    { value: "Ambiente", key: "Ambiente" },
    { value: "Medición", key: "Medición" },
    { value: "Máquina", key: "Máquina" },
    { value: "Método", key: "Método" },
    { value: "Max", key: "Max" },
  ],

  SixMInputTypeListCombined: [
    { value: "Man", key: "Man" },
    { value: "Material", key: "Material" },
    { value: "Machine", key: "Machine" },
    { value: "Method", key: "Method" },
    { value: "Measurement", key: "Measurement" },
    { value: "Environment", key: "Environment" },
    { value: "Hombre", key: "Hombre" },
    { value: "Ambiente", key: "Ambiente" },
    { value: "Medición", key: "Medición" },
    { value: "Máquina", key: "Máquina" },
    { value: "Método", key: "Método" },
    { value: "Max", key: "Max" },
  ],
};

export default NEXUS_CONST;
//commit
